import axios from 'axios'

export const api = axios.create({
  withCredentials: true,
  baseURL: process.env.NODE_ENV === 'production' ? '/bitrix/services/main' : 'https://service.meet-sg.com/bitrix/services/main'
})



// WEBPACK FOOTER //
// ./src/store/http-common.js